import { call, put } from 'redux-saga/effects';
import moment from 'moment';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import localeEN from 'moment/locale/en-gb';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import localeFR from 'moment/locale/fr';

import i18n from 'i18n';
import { AppAPI } from 'services/app.api';
import {
  appConfig,
  productCurrency,
  setAppLoading,
  getCustomMenuItemsAction,
  setMenuLoading,
  appOptions,
  setOptionsLoading,
  userPoints,
  setPointsLoading,
  updateUserConditionsAndTerms,
  featureByName,
  setFeatureLoading,
} from 'actions/app.actions';

export function* getAppConfigSaga() {
  try {
    yield put(setAppLoading(true));
    const { data } = yield call(AppAPI.getAppConfig);
    yield put(appConfig.success(data));
    // translate the app and moment
    yield i18n.changeLanguage(data?.locale);
    yield moment.locale(data?.locale, [localeEN, localeFR]);
    yield put(setAppLoading(false));
  } catch (error) {
    yield put(appConfig.failure(error));
    yield put(setAppLoading(false));
  }
}

export function* getProductCurrencySaga() {
  try {
    yield put(setAppLoading(true));
    const { data } = yield call(AppAPI.getProductCurrency);
    yield put(productCurrency.success(data));
  } catch (error) {
    yield put(productCurrency.failure(error));
  } finally {
    yield put(setAppLoading(false));
  }
}

export function* getAppOptionsSaga() {
  try {
    yield put(setOptionsLoading(true));
    const { data } = yield call(AppAPI.getAppOptions);
    yield put(appOptions.success(data));
    yield put(setOptionsLoading(false));
  } catch (error) {
    yield put(appOptions.failure(error));
    yield put(setOptionsLoading(false));
  }
}

export function* getCustomMenuItemsSaga() {
  try {
    yield put(setMenuLoading(true));
    const { data } = yield call(AppAPI.getMenuItems);
    yield put(getCustomMenuItemsAction.success(data));
    yield put(setMenuLoading(false));
  } catch (error) {
    yield put(getCustomMenuItemsAction.failure(error));
    yield put(setMenuLoading(false));
  }
}

export function* getUserPointsSaga({ payload }: any) {
  const { id } = payload;
  try {
    yield put(setPointsLoading(true));
    const {
      data: { points },
    } = yield call(AppAPI.getUserPoints, id);
    yield put(userPoints.success(Number(points)));
    yield put(setPointsLoading(false));
  } catch (error) {
    yield put(userPoints.failure(error));
    yield put(setPointsLoading(false));
  }
}

export function* patchUserConditionsAndTermsSaga({ payload }: any) {
  const { id } = payload;
  try {
    const { data } = yield call(AppAPI.patchUserConditionsAndTerms, id, {
      isCGUAccepted: true,
    });
    yield put(updateUserConditionsAndTerms.success(data));
  } catch (error) {
    yield put(updateUserConditionsAndTerms.failure(error));
  }
}

export function* getFeatureByNameSaga({ payload }: any) {
  const { name } = payload;
  try {
    yield put(setFeatureLoading(name, true));
    const { data } = yield call(AppAPI.getFeatureByName, name);
    yield put(featureByName.success(name, data[0]));
    yield put(setFeatureLoading(name, false));
  } catch (error) {
    yield put(featureByName.failure(name, error));
    yield put(setFeatureLoading(name, false));
  }
}
